module.exports = __webpack_public_path__ + "img/hero-image-animation.c3ae54d8.gif";